function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".a{fill:#3eb337;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -48.907)"
}, React.createElement("g", {
  transform: "translate(0 48.907)"
}, React.createElement("path", {
  className: "a",
  d: "M11.361,48.907,6.44,53.828,1.519,48.907,0,50.426l6.44,6.44,6.44-6.44Z",
  transform: "translate(0 -48.907)"
})));

var SvgDownChevronGreen = function SvgDownChevronGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12.879,
    height: 7.958,
    viewBox: "0 0 12.879 7.958",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownChevronGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/down-chevron-green.7fd1b7de.svg";
export { ForwardRef as ReactComponent };